import { createSlice } from '@reduxjs/toolkit';

import { fetchRecommendedSimilarItems } from './recommendedSimilarItems.actions';
import { defaultRecommendedSimilarItemsSlice } from './recommendedSimilarItems.types';

const recommendedSimilarItemsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchRecommendedSimilarItems.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(fetchRecommendedSimilarItems.fulfilled, (slice, { payload }) => {
            slice.itemIds = payload.itemIds;
            slice.loaded = payload.actionTime;
            slice.loading = false;
            slice.seedItemIds = payload.seedItemIds;
        });
        builder.addCase(fetchRecommendedSimilarItems.rejected, (slice) => {
            slice.loading = false;
        });
    },
    initialState: defaultRecommendedSimilarItemsSlice,
    name: 'recommendedSimilarItems',
    reducers: {},
});

export const { reducer: recommendedSimilarItemsReducer } = recommendedSimilarItemsSlice;
